import React, { useContext } from "react";
import { useParams } from 'react-router-dom';
import PageContainer from "@components/pages/PageContainer";
import OrdersList from "@components/orders/OrdersList";
import OrderCreate from '@components/orders/OrderCreate';
import OrdersSuccess from '@components/orders/OrdersSuccess';
import OrdersCanceled from '@components/orders/OrdersCanceled';
import OrdersDetails from '@components/orders/OrdersDetails';
import HeaderCredits from "@components/composite/HeaderCredits/HeaderCredits";
import { PageWideScrollBox } from "@components/pages/page.layout";
import { MenuContext } from '@stores/MenuContext';
import { CreditsContext } from "@stores/CreditsContext";
import { ActionMapT, getTitle, getComponent } from '@pages/Pages.utils';

const debug = false;

const actionsMap:ActionMapT = {
  'create': {
    title: 'Purchase More Credits',
    component: <OrderCreate />
  },
  'success': {
    title: 'Purchase Successful',
    component: <OrdersSuccess />
  },
  'canceled': {
    title: 'Purchase Canceled',
    component: <OrdersCanceled />
  },
  'details': {
    title: 'My Order Details',
  },
  'default': {
    title: 'My Previous Orders',
    component: <OrdersList />
  }
}



const PgOrders = () => {
  const { creditsInfo } = useContext(CreditsContext);
  let { action } = useParams(); // this is the action that sets what to do
  let submissionHash = '';
  if (action && action.includes('-')) {
    submissionHash = action;
    action = 'details';
  }
  debug && console.log("PgOrders | action:", action, " submissionHash", submissionHash);
  debug && console.log("PgOrders | creditsInfo:", creditsInfo);
  const { activeMenuId, setActiveMenuId } = useContext(MenuContext);
  if (activeMenuId !== 'myOrders') setActiveMenuId('myOrders');

  return (
    <PageContainer title={getTitle(actionsMap, action)}  >
      { !action || ['default', 'canceled'].includes(action) ? <HeaderCredits /> : null }
      <PageWideScrollBox topMargin={160}>
        { action !== 'details' ?
          getComponent(actionsMap, action)
          :
          <OrdersDetails hash={submissionHash}/>
        }
      </PageWideScrollBox>
    </PageContainer>
  );
};

export default PgOrders;
